import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PageHeading from '../components/PageHeading';
import VerticalSpacer from '../../components_common/VerticalSpacer/VerticalSpacer';
import QuoteText from '../../components_common/Press/QuoteText';
import PressArticles from '../../components_common/Press/PressArticles';
import PressImages from '../../components_common/Press/PressImages';
import PressOpportunitiesHeader from '../../components_common/Press/PressOpportunitiesHeader';
import SolidLineHeader from '../../components_common/Press/SolidLineHeader';

const mapStateToProps = state => ({
  s3BasePath: state.api.s3BasePath
});

const PressComponent = ({ s3BasePath }) => (
  <div>
    <VerticalSpacer height="32px" />
    <PageHeading text="PRESS" />
    <VerticalSpacer height="8px" />
    <PressOpportunitiesHeader />
    <VerticalSpacer height="20px" />
    <img src={`${s3BasePath}press/press_page_desktop.jpg`} style={{ maxWidth: '1280px', width: '100%' }} />
    <VerticalSpacer height="40px" />
    <QuoteText isDesktop />
    <VerticalSpacer height="65px" />
    <PressImages isDesktop s3BasePath={s3BasePath} />
    <VerticalSpacer height="80px" />
    <SolidLineHeader isDesktop />
    <VerticalSpacer height="60px" />
    <PressArticles isDesktop />
  </div>
);

PressComponent.propTypes = {
  s3BasePath: PropTypes.string.isRequired
};

const Press = connect(mapStateToProps)(PressComponent);
export default Press;
